/* eslint-disable no-param-reassign */
import {lazyInitialize} from 'core-decorators';
export {lazyInitialize};
import autobind from 'autobind-decorator';
export {autobind};

export function nonenumerable(target, prop, descriptor) {
  descriptor.enumerable = false;
}
export function writable(target, prop, descriptor) {
  descriptor.writable = true;
}

export function instanceOf(Klass) {
  if (typeof Klass !== 'function') {
    throw new Error('Invalid use of @instanceOf');
  }
  function ensure(value) {
    if (value && !(value instanceof Klass)) {
      value = Object.assign(new Klass(this.ctx), value);
    }
    return value;
  }
  return (target, prop, descriptor) => {
    let val = descriptor.value;

    if (
      (descriptor.get && !descriptor.set) ||
      (!descriptor.get && descriptor.set)
    ) {
      throw new Error('Invalid use of @instanceOf');
    }

    const {
      get = function get() { return val; },
      set = function set(value) { val = value; },
    } = descriptor;
    let {
      initializer,
    } = descriptor;

    descriptor.get = function () {
      if (initializer) {
        val = ensure.call(this, initializer.call(this));
        initializer = null;
      }
      return get.call(this);
    };
    descriptor.set = function (value) {
      return set.call(this, ensure.call(this, value));
    };

    delete descriptor.value;
    delete descriptor.initializer;
    delete descriptor.writable;

    Object.defineProperty(target, prop, descriptor);

    return descriptor;
  };
}



// WEBPACK FOOTER //
// ./spa/decorators.jsx